import Vue from "vue";
import { GenericApi } from "@/apis";

import { convertArrayToObject } from "@/common/helpers";

const state = {
  countries: {},
  cities: {},
};

const mutations = {
  setCountries(state, countries) {
    Vue.set(state, "countries", convertArrayToObject(countries, "id"));
  },
  setCities(state, cities) {
    Vue.set(state, "cities", convertArrayToObject(cities, "id"));
  },
};

const actions = {
  async getCountries({ commit }) {
    const response = await GenericApi.getCountries();
    const localities = response.data.data;
    commit("setCountries", localities);
  },
  async getCities({ commit }, country_id) {
    const response = await GenericApi.getCities({
      country_id: country_id,
    });
    const localities = response.data.data;
    commit("setCities", localities);
  },
  async getCitiesById({ commit }, city_id) {
    const response = await GenericApi.getCities({
      id: city_id,
    });
    const localities = response.data.data;
    commit("setCities", localities);
  },
};

const getters = {
  countries(state) {
    return Object.values(state.countries);
  },
  cities: (state) => (country_id) => {
    return Object.values(state.cities)
      .filter((x) => x.country_id == country_id)
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
  },
  allCities(state) {
    return state.cities;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
